import axios from "axios";

const API_URL =
  process.env.REACT_APP_API_URL || "https://sms-781s.onrender.com";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const initializeChat = async (phone_number: string) => {
  try {
    const response = await api.post("/init-chat", { phone_number });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(
        error.response.data?.error || "Failed to initialize chat"
      );
    } else {
      throw new Error("Failed to initialize chat");
    }
  }
};

export const sendMessage = async (
  phone_number: string,
  message: string,
  seller: boolean
) => {
  try {
    const response = await api.post(`/send-message${seller ? "-seller" : ""}`, {
      phone_number,
      message,
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data?.error || "Failed to send message");
    } else {
      throw new Error("Failed to send message");
    }
  }
};

export const sendSessionMessage = async (message: string, seller: boolean) => {
  try {
    const sessionId = sessionStorage.getItem("sessionId");
    const response = await api.post(
      `/send-message-${seller ? "seller" : "session"}`,
      {
        sessionId,
        message,
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data?.error || "Failed to send message");
    } else {
      throw new Error("Failed to send message");
    }
  }
};
